const url = window.location.origin;

export const getEnv = () => {
  switch (true) {
    case url.includes('dsmotd.toyota.com'):
      return 'prod';
    case url.includes('dsmotduat.toyota.com'):
      return 'uat';
    case url.includes('dsmotdqa.toyota.com'):
      return 'qa';
    case url.includes('dsmotdsit.toyota.com'):
      return 'sit';
    case url.includes('dsmotddev.toyota.com'):
    case url.includes('localhost'):
    default:
      return 'dev';
  }
};

export const getBaseURL = () =>
  ({
    dev: 'dsmotddev.toyota.com',
    qa: 'dsmotdqa.toyota.com',
    uat: 'dsmotduat.toyota.com',
    sit: 'dsmotdsit.toyota.com',
    prod: 'dsmotd.toyota.com',
  }[getEnv()]);

const vspecGuest = 'https://guest.dealer.qa.toyota.com';
const vSpecHash = 'https://api.rti.qa.toyota.com';
const vSpecXKey = '***REMOVED***';

export const getVspecParams = () =>
  ({
    dev: {
      vSpecGuestUrl: vspecGuest,
      vSpecHashUrl: vSpecHash,
      vSpecXApiKey: vSpecXKey,
    },
    qa: {
      vSpecGuestUrl: vspecGuest,
      vSpecHashUrl: vSpecHash,
      vSpecXApiKey: vSpecXKey,
    },
    uat: {
      vSpecGuestUrl: vspecGuest,
      vSpecHashUrl: vSpecHash,
      vSpecXApiKey: vSpecXKey,
    },
    sit: {
      vSpecGuestUrl: vspecGuest,
      vSpecHashUrl: vSpecHash,
      vSpecXApiKey: vSpecXKey,
    },
    prod: {
      vSpecGuestUrl: 'https://guest.dealer.toyota.com',
      vSpecHashUrl: 'https://api.rti.toyota.com',
      vSpecXApiKey: '***REMOVED***',
    },
  }[getEnv()]);
